<app-navbar></app-navbar>
<div class="crear-producto-container">
  <h1>Gestión de productos para el alojamiento</h1>
  <p *ngIf="alojamientoName"><strong>{{ alojamientoName }}</strong></p>
  <!-- Selector para alternar entre crear producto y carga masiva -->
  <div>
    <label for="modo">Modo:</label>
    <select id="modo" [(ngModel)]="modoSeleccionado">
      <option value="individual">Crear Producto</option>
      <option value="masiva">Carga Masiva</option>
    </select>
  </div>
  <form *ngIf="modoSeleccionado === 'individual'" [formGroup]="productoForm" (ngSubmit)="crearProducto()">
    <h2>Crear Producto</h2>
    <div>
      <label for="nombre">Nombre:</label>
      <input id="nombre" formControlName="nombre" type="text" />
    </div>
    <div>
      <label for="descripcion">Descripción</label>
      <textarea id="descripcion" formControlName="descripcion"></textarea>
    </div>
    <!--<div>
      <label for="imagen">Seleccionar imagen:</label>
      <input type="file" id="imagen" (change)="onFileSelected($event)" />
    </div> -->
    <div>
      <label for="valor_neto">Valor Neto:</label>
      <input id="valor_neto" formControlName="valor_neto" type="number" />
    </div>
    <div>
      <label for="porcentaje_impuestos">Porcentaje Impuestos:</label>
      <input id="porcentaje_impuestos" formControlName="porcentaje_impuestos" type="number" />
    </div>    
    <div>
      <label for="stock">Stock:</label>
      <input id="stock" formControlName="stock" type="number" />
    </div>    
    <button type="submit">Crear Producto</button>
  </form>
  <!-- Formulario para carga masiva -->
  <div *ngIf="modoSeleccionado === 'masiva'">
    <h3>Carga Masiva de Productos</h3>
    <div>
      <label for="archivoExcel">Seleccionar archivo Excel:</label>
      <input type="file" id="archivoExcel" (change)="onExcelFileSelected($event)" accept=".xlsx, .xls" />
    </div>
    <button (click)="cargarProductosMasivos()">Cargar Productos</button>
    <div class="ejemplo-descarga-container">
      <p class="ejemplo-texto">¿Necesitas un ejemplo? Descarga la plantilla de ejemplo:</p>
      <a href="https://ecoturismo-images-app.s3.us-east-1.amazonaws.com/plantilla_productos.xlsx" 
          download="plantilla_carga_masiva.xlsx" 
          class="ejemplo-download-link"
          target="_blank"
          rel="noopener">
        <span class="download-icon">⬇️</span>
        <span>Descargar plantilla de ejemplo</span>
      </a>
    </div>
  </div>
  <div *ngIf="cargandoErrores" style="margin-top: 1rem;">
    <span>Cargando...</span>
  </div>
  <div *ngIf="!cargandoErrores && listaErrores.length > 0">
    <h3>Archivos de errores disponibles:</h3>
    <ul>
      <li *ngFor="let key of listaErrores">
        {{ key }}
        <button (click)="descargarErrores(key)">Descargar</button>
      </li>
    </ul>
  </div>
</div>
<app-footer></app-footer>